import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { ViewController } from 'foundations-components/transitional/components/ViewController';
import unescapedText from 'I18n/utils/unescapedText';
import I18n from 'I18n';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import { jsx as _jsx } from "react/jsx-runtime";
const FilterOperatorBoolInput = ({
  ['data-selenium-test']: dataSeleniumTest,
  disabled,
  error,
  onChange,
  readOnly,
  value
}) => /*#__PURE__*/_jsx(FormControl, {
  "aria-label": I18n.text('customerDataFiltersUI.customerDataFilters.FilterOperatorInput.ariaLabel'),
  error: error.get('error'),
  validationMessage: error.get('error') ? error.get('message') : null,
  children: /*#__PURE__*/_jsx(ViewController, {
    "data-selenium-test": dataSeleniumTest,
    onChange: e => onChange(syntheticEvent(e.target.value === 'true')),
    options: [{
      disabled: disabled || readOnly,
      text: unescapedText('customerDataFiltersUI.customerDataFilters.DisplayValue.booleanTrue'),
      value: 'true'
    }, {
      disabled: disabled || readOnly,
      text: unescapedText('customerDataFiltersUI.customerDataFilters.DisplayValue.booleanFalse'),
      value: 'false'
    }],
    value: `${value}`
  })
});
export default FilterOperatorBoolInput;